import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import {
  IonApp,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonRouterOutlet,
  IonSplitPane,
} from '@ionic/vue';
import {onMounted, ref} from 'vue';
import {cogOutline, cogSharp, gitBranchOutline, gitBranchSharp, homeOutline, homeSharp} from 'ionicons/icons';
import {useRoute} from "vue-router";
import {useProfile, userProfileStore} from "@/composables/profile";
import {addListeners, registerNotifications} from "@/composables/notifications";
import {Capacitor} from "@capacitor/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const profile = useProfile();
const selectedIndex = ref(0);

onMounted(async () => {
  await profile.reloadProfile()

  if (Capacitor.getPlatform() === 'android') {
    await addListeners()
    await registerNotifications()
  }
});

const appPages = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    iosIcon: homeOutline,
    mdIcon: homeSharp,
  },
  {
    title: 'Assigned MRs',
    url: '/assigned-mrs',
    iosIcon: gitBranchOutline,
    mdIcon: gitBranchSharp,
  },
  {
    title: 'Review MRs',
    url: '/review-mrs',
    iosIcon: gitBranchOutline,
    mdIcon: gitBranchSharp,
  },
  {
    title: 'Renovate MRs',
    url: '/renovate-mrs',
    iosIcon: gitBranchOutline,
    mdIcon: gitBranchSharp,
  },
  {
    title: 'Compare Branches',
    url: '/compare-branches',
    iosIcon: cogOutline,
    mdIcon: cogSharp,
  },
  {
    title: 'Settings',
    url: '/settings',
    iosIcon: cogOutline,
    mdIcon: cogSharp,
  }
];

selectedIndex.value = appPages.findIndex(p => p.url === route.path)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonMenu), {
            "content-id": "main-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonList), { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonListHeader), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gitlab Manager")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(userProfileStore).username), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPages, (p, i) => {
                        return _createVNode(_unref(IonMenuToggle), {
                          "auto-hide": "false",
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              onClick: ($event: any) => (selectedIndex.value = i),
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: "none",
                              detail: "false",
                              class: _normalizeClass(["hydrated", { selected: selectedIndex.value === i }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  "aria-hidden": "true",
                                  slot: "start",
                                  ios: p.iosIcon,
                                  md: p.mdIcon
                                }, null, 8, ["ios", "md"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "class"])
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})